import { useCurrentWidth } from '@shoflo/polymer';
import { _768P } from 'constants/ScreenDimensions';

/**
 * The `thresholdWidth` is the width (in pixels) at which or below which the
 * hook determines that the device is mobile. It defaults to
 * _768P.
 * @param thresholdWidth
 * @returns {boolean}
 */
const useIsMobile = (thresholdWidth = _768P) => {
  const width = useCurrentWidth();

  return width <= thresholdWidth;
};

export default useIsMobile;
